import React, { useEffect } from "react";
import { useForm } from "react-hook-form";
import ReactQuill from "react-quill";
import "react-quill/dist/quill.snow.css";
import api from "../../api/api";

const Edit = ({ item, setOptions, setWarning, handleOpenSnackbar }) => {
  const {
    register,
    handleSubmit,
    setValue,
    watch,
    formState: { errors },
  } = useForm({
    defaultValues: {
      position: item.position,
      text: item.text,
      button: item.button,
      textButton: item.textButton,
    },
  });

  const handleQuillChange = (value) => {
    setValue("text", value, { shouldValidate: true });
  };

  useEffect(() => {
    setValue("position", item.position);
    setValue("text", item.text);
    setValue("button", item.button);
    setValue("textButton", item.textButton);
  }, [item, setValue]);

  const showText = watch("text");
  const showTextButton = watch("button");

  const onSubmit = (formData) => {
    api
      .post("/banners/line", formData)
      .then((response) => {
        if (response.status === 200 || response.status === 201) {
          setWarning({
            type: "success",
            message: "Faixa de Texto editada com sucesso!",
          });
          handleOpenSnackbar();
          setOptions("");
        } else {
          setWarning({
            type: "warning",
            message:
              "Faixa de Texto editada, mas com respostas inesperadas do servidor.",
          });
          handleOpenSnackbar();
          setOptions("");
        }
      })
      .catch((error) => {
        let errorMessage = "Falha ao editar a Faixa de Texto no servidor!";
        if (error.response) {
          errorMessage += ` Detalhes: ${
            error.response.data.message || error.response.status
          }`;
        } else if (error.request) {
          errorMessage = "O servidor não respondeu ao pedido.";
        } else {
          errorMessage = "Erro ao enviar o pedido para o servidor.";
        }
        setWarning({
          type: "error",
          message: errorMessage,
        });
        handleOpenSnackbar();
      });
  };

  return (
    <div className="max-w-7xl mx-auto p-6">
      <div className="mb-8">
        <h1 className="text-3xl font-bold text-gray-800 mb-2">
          Editar Faixa de Texto
        </h1>
        <p className="text-gray-600">
          Modifique as configurações da faixa de texto existente
        </p>
      </div>

      <div className="grid grid-cols-1 lg:grid-cols-3 gap-8">
        {/* Formulário - Lado Esquerdo */}
        <div className="lg:col-span-2">
          <form onSubmit={handleSubmit(onSubmit)} className="space-y-6">
            <div className="bg-white border border-gray-200 rounded-lg p-6">
              <h3 className="text-lg font-semibold text-gray-800 mb-4">
                Configurações Básicas
              </h3>

              <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                <div>
                  <label
                    htmlFor="position"
                    className="block text-sm font-medium text-gray-700 mb-2"
                  >
                    Posição da Faixa *
                  </label>
                  <select
                    id="position"
                    {...register("position", {
                      required: "Selecione uma posição",
                    })}
                    className="w-full p-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500 transition-colors"
                  >
                    <option value="">Escolha uma opção</option>
                    <option value="TOP">Topo</option>
                    <option value="ABOVE_HEADER">Abaixo do Carrossel</option>
                  </select>
                  {errors["position"] && (
                    <p className="mt-1 text-sm text-red-600">
                      {errors["position"].message || "Este campo é obrigatório"}
                    </p>
                  )}
                </div>

                <div>
                  <label
                    htmlFor="type"
                    className="block text-sm font-medium text-gray-700 mb-2"
                  >
                    Tipo de Usuário *
                  </label>
                  <select
                    {...register("type", { required: "Selecione um tipo" })}
                    className="w-full p-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500 transition-colors"
                  >
                    <option value="">Selecione uma opção</option>
                    <option value="FOR_YOU">Para você</option>
                    <option value="FOR_BUSINESS">Para salão</option>
                  </select>
                  {errors["type"] && (
                    <p className="mt-1 text-sm text-red-600">
                      {errors["type"].message || "Este campo é obrigatório"}
                    </p>
                  )}
                </div>
              </div>
            </div>

            <div className="bg-white border border-gray-200 rounded-lg p-6">
              <h3 className="text-lg font-semibold text-gray-800 mb-4">
                Conteúdo da Mensagem
              </h3>

              <div className="mb-4">
                <label
                  htmlFor="text"
                  className="block text-sm font-medium text-gray-700 mb-2"
                >
                  Texto da Faixa *
                </label>
                <div className="border border-gray-300 rounded-lg overflow-hidden">
                  <ReactQuill
                    theme="snow"
                    onChange={handleQuillChange}
                    value={showText}
                    modules={Edit.modules}
                    formats={Edit.formats}
                    placeholder="Escreva sua mensagem..."
                    className="bg-white"
                  />
                </div>
                {errors.text && (
                  <p className="mt-1 text-sm text-red-600">
                    {errors.text.message}
                  </p>
                )}
              </div>
            </div>

            <div className="bg-white border border-gray-200 rounded-lg p-6">
              <h3 className="text-lg font-semibold text-gray-800 mb-4">
                Configurações de Cupom (Opcional)
              </h3>

              <div className="mb-4">
                <div className="flex items-center">
                  <input
                    type="checkbox"
                    id="checkbox"
                    {...register("button")}
                    className="h-4 w-4 text-blue-600 bg-white border border-gray-300 rounded focus:ring-2 focus:ring-blue-500 focus:ring-offset-0"
                  />
                  <label
                    htmlFor="checkbox"
                    className="ml-3 block text-sm font-medium text-gray-700"
                  >
                    Adicionar código de cupom
                  </label>
                </div>
              </div>

              {showTextButton && (
                <div className="bg-green-50 border border-green-200 rounded-lg p-4">
                  <label
                    htmlFor="textButton"
                    className="block text-sm font-medium text-green-800 mb-2"
                  >
                    Código do Cupom *
                  </label>
                  <input
                    type="text"
                    id="textButton"
                    placeholder="Digite o código do cupom"
                    {...register("textButton", {
                      required: "Código do cupom é obrigatório quando ativado",
                    })}
                    className="w-full p-3 border border-green-300 rounded-lg focus:ring-2 focus:ring-green-500 focus:border-green-500 transition-colors bg-white"
                  />
                  {errors.textButton && (
                    <p className="mt-1 text-sm text-red-600">
                      {errors.textButton.message}
                    </p>
                  )}
                </div>
              )}
            </div>

            <div className="flex gap-4 pt-6">
              <button
                type="button"
                onClick={() => setOptions("")}
                className="px-6 py-3 border border-gray-300 text-gray-700 rounded-lg hover:bg-gray-50 transition-colors"
              >
                Cancelar
              </button>
              <button
                type="submit"
                className="bg-blue-500 hover:bg-blue-700 text-white font-bold py-3 px-6 rounded focus:outline-none focus:shadow-outline transition duration-300 ease-in-out transform hover:scale-105"
              >
                Salvar Alterações
              </button>
            </div>
          </form>
        </div>

        {/* Caixa de Alerta - Lado Direito */}
        <div className="lg:col-span-1">
          <div className="bg-yellow-50 border border-yellow-200 rounded-lg p-6 sticky top-6">
            <h2 className="text-xl font-semibold text-yellow-800 mb-3">
              Editando Faixa Existente
            </h2>
            <div className="space-y-3">
              <div className="flex items-start gap-3">
                <div className="w-2 h-2 bg-yellow-500 rounded-full mt-2 flex-shrink-0"></div>
                <p className="text-yellow-700">
                  <strong>Posição:</strong>{" "}
                  {item.position === "TOP" ? "Topo" : "Abaixo do Carrossel"}
                </p>
              </div>
              <div className="flex items-start gap-3">
                <div className="w-2 h-2 bg-yellow-500 rounded-full mt-2 flex-shrink-0"></div>
                <p className="text-yellow-700">
                  <strong>Tipo:</strong>{" "}
                  {item.type === "FOR_YOU" ? "Para você" : "Para salão"}
                </p>
              </div>
              <div className="flex items-start gap-3">
                <div className="w-2 h-2 bg-yellow-500 rounded-full mt-2 flex-shrink-0"></div>
                <p className="text-yellow-700">
                  <strong>Cupom:</strong> {item.button ? "Ativo" : "Inativo"}
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Edit;

Edit.modules = {
  toolbar: [
    [{ header: "1" }, { header: "2" }],
    [{ size: [] }],
    ["bold", "italic", "underline", "strike", "blockquote"],
    [
      { list: "ordered" },
      { list: "bullet" },
      { indent: "-1" },
      { indent: "+1" },
    ],
    ["link"],
    ["clean"],
  ],
  clipboard: {
    matchVisual: true,
  },
};

Edit.formats = [
  "header",
  "size",
  "bold",
  "italic",
  "underline",
  "strike",
  "blockquote",
  "list",
  "bullet",
  "indent",
  "link",
];
